module.exports = __webpack_public_path__ + "20d58b0f72e5c0f2c19b7d010304d8d6.png";